import React from 'react';
import { Page, Text, View, Image, Document } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import OKR_LOGO from '../../../images/Unlock_U_Logo.png';
import { getMonthDateYear, getMonthDateYearTime } from '../../../config/utils';
import { styles } from '../PerformanceImprovementPlan/PipPdfStyle';

const Field = ({ title, value }) => (
	<View style={styles.employeeCol}>
		<Text style={styles.employeeColTitle}>{title}</Text>
		<Text style={[styles.employeeColText, styles.fontMedium]}>{value || '--'}</Text>
	</View>
);

export function FeedbackDetailPdf({ data }) {
	const reviewers = (data?.feedbackReviewerResponse || [])
		.map((r) => `${r?.firstName || ''} ${r?.lastName || ''}`.trim())
		.filter(Boolean)
		.join(', ');
	const hasTimeframe = data?.timeframeStartDate && data?.timeframeEndDate;

	return (
		<Document>
			<Page size='A4' style={styles.pageFirst}>
				<View style={styles.pageFirst_wrap}>
					<View style={styles.pageHeaderSection}>
						{Boolean(data?.companyLogo?.trim()) && (
							<Image style={styles.customerLogo} source={{ uri: data.companyLogo, method: 'GET' }} />
						)}
						<Image style={styles.unlockULogo} source={OKR_LOGO} />
					</View>
					<View style={styles.pipMainHeader}>
						<Text style={[styles.pipMainHeaderText, styles.fontMedium]}>Feedback</Text>
					</View>
					<View style={styles.pipSectionTitle}>
						<Text style={[styles.pipSectionTitleText, styles.fontMedium]}>General Details</Text>
					</View>
					<View style={styles.employeeRow}>
						<Field title='Employee Name' value={`${data?.nomineeDetails?.firstName || ''} ${data?.nomineeDetails?.lastName || ''}`.trim()} />
						<Field title='Title' value={data?.title} />
					</View>
					<View style={styles.employeeRow}>
						<Field title='Feedback Type' value={data?.feedbackType} />
						<Field title='Category' value={data?.feedbackCategory} />
					</View>
					<View style={styles.employeeRow}>
						<Field title='Status' value={data?.feedbackStatus} />
						<Field title='Created On' value={data?.createdOn && getMonthDateYearTime(data.createdOn)} />
					</View>
					<View style={styles.employeeRow}>
						<Field
							title='Timeframe'
							value={hasTimeframe && `${getMonthDateYear(data.timeframeStartDate)} - ${getMonthDateYear(data.timeframeEndDate)}`}
						/>
						<Field title='Resolved On' value={data?.resolvedOn && getMonthDateYear(data.resolvedOn)} />
					</View>
					<View style={styles.employeeRow}>
						<Field title='Reviewers' value={reviewers} />
					</View>
					{Boolean(data?.summary) && (
						<View style={styles.pipBlock}>
							<View style={styles.pipBlockHead}>
								<Text style={styles.pipBlockHeadTitle}>Summary</Text>
							</View>
							<View style={styles.editorBox}>
								<Html stylesheet={[styles]}>{data.summary}</Html>
							</View>
						</View>
					)}
				</View>
			</Page>
		</Document>
	);
}
